import type { IconName } from '../components/hbs/Icon';

/** The fixed glyph set an admin can assign to a Binder category. `folder` is
 *  the default. Shared by the management UI (the picker) and the sidebar rail
 *  (rendering the chosen glyph) so the two never drift. */
export const CATEGORY_ICONS: IconName[] = [
  'folder', 'card', 'note', 'identity', 'contact', 'key', 'heart', 'safe',
];

/** Resolve a stored category `icon` string to a known glyph, defaulting to
 *  `folder` for anything unrecognized (older records, or a glyph since removed). */
export function categoryIconName(icon?: string): IconName {
  return CATEGORY_ICONS.includes(icon as IconName) ? (icon as IconName) : 'folder';
}
